document.addEventListener('change', (e) => {
  e.target.matches('.dropdown-page-nav') && (window.location.href = e.target.value)
})
